import * as React from 'react';

import type { CampaignClient } from '@/api/campaign-client';
import { HttpCampaignClient } from '@/api/campaign-client.http';

// =============================================================================
// campaign-client-context.tsx — Injection du CampaignClient (DI seam).
// =============================================================================
// Permet de substituer le client sans toucher l'UI. Par défaut (S11) : l'adaptateur
// HTTP RÉEL (HttpCampaignClient) — le câblage front↔back contre le contrat de routes
// figé. Les tests de composant injectent le StubCampaignClient (double déterministe)
// via le provider ; l'E2E intégré (ST-CAMPAIGN-01) exerce l'adaptateur réel.

/** Adaptateur par défaut : HTTP réel (chemins relatifs racine API, cookie de session). */
const defaultCampaignClient: CampaignClient = new HttpCampaignClient();

const CampaignClientContext =
  React.createContext<CampaignClient>(defaultCampaignClient);

export interface CampaignClientProviderProps {
  client?: CampaignClient | undefined;
  children: React.ReactNode;
}

export function CampaignClientProvider({
  client = defaultCampaignClient,
  children,
}: CampaignClientProviderProps): React.JSX.Element {
  return (
    <CampaignClientContext.Provider value={client}>
      {children}
    </CampaignClientContext.Provider>
  );
}

export function useCampaignClient(): CampaignClient {
  return React.useContext(CampaignClientContext);
}
